<template>
  <PModal
    title="Confirmer la suppression du flux"
    :model-value="props.modelValue"
    @update:model-value="emit('update:modelValue', $event)"
    @open="onOpen"
  >
    <template #default>
      <div>
        <div class="mb-4">
          Voulez-vous vraiment supprimer
          <span class="font-bold">{{ streamElement.mail }}</span> du flux ?
        </div>

        <div>
          <PTooltip
            label="L'utilisateur est déjà en copie"
            placement="top-start"
            :offset="5"
            :delay="500"
            :disabled="!isInCc(streamElement)"
          >
            <PCheckbox
              v-model="addToCC"
              label="Ajouter l'utilisateur en copie"
              :disabled="isInCc(streamElement)"
              hide-messages
            />
          </PTooltip>
          <div class="mt-2 italic">
            L'utilisateur en copie pourra toujours consulter le parapheur et prendre la main.
          </div>
        </div>
      </div>
    </template>
    <template #actions="{ close }">
      <div class="flex gap-1 items-end justify-end">
        <PButton mode="secondary" @click="close">Annuler</PButton>
        <PButton mode="primary" @click="emit('deleteFromStream', streamElement, addToCC)"> Supprimer du flux </PButton>
      </div>
    </template>
  </PModal>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { type FluxElementDto } from "../../../dto/flux-element.dto";
import { PModal, PButton, PCheckbox, PTooltip } from "@pasta/box-v2";

interface Props {
  modelValue: boolean;
  isInCc: (element: FluxElementDto) => boolean;
  streamElement: FluxElementDto;
}

const props = defineProps<Props>();

const emit = defineEmits<{
  (event: "deleteFromStream", element: FluxElementDto, addToCC: boolean): void;
  (event: "update:modelValue", value: boolean): void;
}>();

const addToCC = ref(false);

function onOpen() {
  addToCC.value = !props.isInCc(props.streamElement);
}
</script>
